import React, {  useEffect, useState } from "react";
import "./Navbar.css"; // Import CSS file for styling
import { getFirstSixLetters,routeObject } from "../constant/constant";
import { Link, useLocation, useNavigate} from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsStaggered,faVideo,faQuestionCircle,faStar,faWallet, faUser, faClockRotateLeft, faLongArrowAltLeft, faLessThan} from '@fortawesome/free-solid-svg-icons';
import IconWithRoundedBorder from "../components/borderCir/BoderCir";
import NavImage from "./NavImage";
export default function Navbar() {
  const { Info } = useSelector((state) => state.users);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [pageName, setpageName] = useState('');
  const location = useLocation();
  const navigate = useNavigate();


  const handleBackClick = () => {
      navigate(-1); // Go back to the previous page
  };

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const logoutComp =()=>{
    localStorage.removeItem('user-session');
    localStorage.clear();
    window.location.href='/login';
  }

  const  toNormalCase=(str)=> {
    return str
      .toLowerCase() // Ensure the entire string is lowercase
      .split(' ')    // Split the string into an array of words
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1); // Capitalize the first letter of each word
      })
      .join(' ');    // Join the array back into a string
  }

  useEffect(()=>{
    if(location.pathname.includes('fund_histry')){
      setpageName(toNormalCase(location.pathname.split('/')[location.pathname.split('/')?.length-1]?.split('_').join(' ')));
    }else if(location.pathname.includes('game_type')){
      setpageName(location.pathname.split('/')[3-1]?.split('_').join(' '));
    }else if(routeObject[location.pathname]){
      setpageName(routeObject[location.pathname]);
    }else{
      setpageName(location.pathname.split('/')[location.pathname.split('/')?.length-1]?.split('_').join(' '));
    }
  },[location.pathname]);


  // const handlePageClick = (event) => {
  //   if (!event.target.classList.contains("missed")) {
  //    setIsMenuOpen(false);
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("click", handlePageClick);
  //   return () => {
  //     document.removeEventListener("click", handlePageClick);
  //   };
  // }, []);


  
  return (
    // <nav className="navbar">
    //   <div className="navbar-container">
    //     {/* Logo */}
    //     <Link to="/" className="navbar-logo">
    //       {APP_NAME}
    //     </Link>

    //     {/* Desktop Links */}
    //     <ul className={`nav-links ${isMenuOpen ? "active" : ""}`}>
    //       <li><Link to="/">Home</Link></li>
    //       {(Info?.status=='1')?<><li><Link to="/profile">My Profile</Link></li>
    //       <li><Link to="/my-bid">My Bid</Link></li>
    //       <li><Link to="/account-statement">Account Statement</Link></li>
    //       <li><Link to="/game-rates">Game Rates</Link></li>
    //       <li><Link to="/how-to-play">How to Play</Link></li>
    //       <li><Link to="/privacy-policy">Privacy Policy</Link></li></>:<></>}
    //       <li><Link to="/logout" onClick={logoutComp}>Logout</Link></li>
    //     </ul>

    //     {/* Toggle Button for Mobile */}
    //     <button className="menu-toggle missed"  onClick={toggleMenu}>
    //       <span className="bar missed"></span>
    //       <span className="bar missed"></span>
    //       <span className="bar missed"></span>
    //     </button>
    //   </div>
    // </nav>

    <div id="app__" style={{position:'fixed',width:'100%',zIndex:9000}}>
      {/* Header */}
      <header className="header">
        {(location.pathname === '/home' || location.pathname === '/')?<button onClick={toggleSidebar} className="toggle-button">
         <IconWithRoundedBorder outerColor={'red'} innerColor={'red'}  FonCompo={<FontAwesomeIcon icon={faBarsStaggered} size="1x" color="white"></FontAwesomeIcon>}/>
        </button>:<div onClick={handleBackClick}><IconWithRoundedBorder outerColor={'red'} innerColor={'red'}  FonCompo={<FontAwesomeIcon icon={faLessThan} size="1x" color="white"></FontAwesomeIcon>}/></div>} &nbsp;&nbsp;&nbsp;&nbsp;
        {(location.pathname === '/home' || location.pathname === '/')?<NavImage/>:<div style={{whiteSpace:'nowrap',fontWeight:'600'}}>{pageName}</div>}
        
        {Info?.status==='1'&&<div className="leftHeader" >
          <span style={{marginTop:'4%',fontWeight:'400',color:'black'}}  >{Info?.wallet}</span> &nbsp;
          <IconWithRoundedBorder outerColor={'red'} innerColor={'red'}  FonCompo={<FontAwesomeIcon icon={faWallet} size="1x" color="white"></FontAwesomeIcon>}/>
          &nbsp;&nbsp;&nbsp;
        </div>}
      </header>

      {/* Sidebar */}
      <aside className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <div className="side_tops" >
          <div className="side_tops" style={{padding:'6%'}} >
        <div >
        <IconWithRoundedBorder outerColor={'gray'} innerColor={'gray'}  FonCompo={<FontAwesomeIcon icon={faUser} size="2x" color="red"></FontAwesomeIcon>}/>
        </div>
        <div style={{}}>
              <span className="name_clm nrwap">{getFirstSixLetters(Info?.name)}</span><br/>
              <span style={{fontSize:'small'}} className="nrwap">+91{Info?.phone_number}</span><br/>
              <span style={{fontSize:'small'}} className="nrwap">Since {Info?.created_at}</span>
        </div>
        </div>
        <div>
          <button onClick={closeSidebar} className="close-button">
              ✖
            </button>
            </div>

        </div>
        <ul className="menu_left">
        {Info?.status==='1'&&<><li ><Link to="/account-statement" onClick={closeSidebar}><IconWithRoundedBorder paddingBox={'10px'} outerColor={'red'} innerColor={'red'}  FonCompo={<FontAwesomeIcon icon={faClockRotateLeft} size='1x' color="white" cursor='pointer'/>}/> &nbsp;Account Statement</Link></li>
        <li><Link to="/game-rates" onClick={closeSidebar}><IconWithRoundedBorder paddingBox={'10px'} outerColor={'red'} innerColor={'red'}  FonCompo={<FontAwesomeIcon icon={faStar} size='1x' color="white" cursor='pointer'/>}/>&nbsp;Game Rates</Link></li>
        <li><Link to="/privacy-policy" onClick={closeSidebar}><IconWithRoundedBorder paddingBox={'10px'} outerColor={'red'} innerColor={'red'}  FonCompo={<FontAwesomeIcon icon={faQuestionCircle} size='1x' color="white" cursor='pointer'/>}/>&nbsp;Term & Conditions</Link></li>
        <li><Link to="/how-to-play" onClick={closeSidebar}><IconWithRoundedBorder  paddingBox={'10px'} outerColor={'red'} innerColor={'red'}  FonCompo={<FontAwesomeIcon icon={faVideo} size='1x' color="white" cursor='pointer'/>}/> &nbsp;Video</Link></li></>}
        <li><Link to="/logout" onClick={logoutComp}><IconWithRoundedBorder paddingBox={'10px'} outerColor={'red'} innerColor={'red'}  FonCompo={<FontAwesomeIcon icon={faLongArrowAltLeft} size='1x' color="white" cursor='pointer'/>}/>&nbsp;Logout</Link></li>
        </ul>
      </aside>
      </div>
  );
}
